import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoAnimated from "../components/LogoAnimated";
import LogoDishub from "../assets/logoDishub.png";

const LandingPage = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // fade in
    setVisible(true);

    // fade out sebelum pindah
    const fadeOutTimer = setTimeout(() => {
      setVisible(false);
    }, 1700);

    // pindah halaman
    const navTimer = setTimeout(() => {
      navigate("/beranda");
    }, 2000);

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(navTimer);
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.5s ease",
      }}
    >
      {/* LOGO UTAMA */}
      <LogoAnimated />

      {/* SUBTITLE + DISHUB */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mt: 1.5,
          animation: "fadeIn 1s ease forwards",
          animationDelay: "0.4s",
          opacity: 0,
          "@keyframes fadeIn": {
            from: { opacity: 0, transform: "translateY(4px)" },
            to: { opacity: 1, transform: "translateY(0)" },
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#64748b",
            fontSize: 13,
          }}
        >
          by Pusat Data dan Informasi
        </Typography>

        <Box
          component="img"
          src={LogoDishub}
          alt="Dishub"
          sx={{
            height: 22,
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
};

export default LandingPage;
